import React from "react";
import { useTranslation } from "react-i18next";
import SecondaryButton from "Shared/Buttons/SecondaryButton";
import Remove from "src/components/icons/Remove";

interface Props {
    isUpdating: boolean;
    isSelected: boolean;
    handleAdd: () => void;
    handleRemove: () => void;
}

export const SelectionButton = ({ isSelected, isUpdating, handleAdd, handleRemove }: Props) => {
    const { t } = useTranslation();

    if (isSelected) {
        return (
            <div>
                <div
                    className={`accessories_remove_button`}
                    style={{ cursor: isUpdating ? `progress` : `pointer` }}
                    onClick={isUpdating ? undefined : handleRemove}
                >
                    <span>
                        <Remove className={`accessories_remove_icon`} />
                    </span>
                    <span className={`accessories_remove_text`}>{t("AccessoryCard.removeBtn")}</span>
                </div>
            </div>
        );
    }

    return (
        <div>
            <SecondaryButton
                style={{ cursor: isUpdating ? `progress` : `pointer` }}
                onClick={isUpdating ? undefined : handleAdd}
            >
                {t("AccessoryCard.selectBtn")}
            </SecondaryButton>
        </div>
    );
};

export default SelectionButton;
